
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employer",
      function () {
        return require("private-next-pages/employer/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employer"])
      });
    }
  